import React from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import Container from '../../../components/Container';
import Section from '../../../components/Section';
import styled from '../../../styled-components';
import HiringManagerVideo from './HiringManagerVideo';

interface PersonalWelcomeProps {
    firstName: string;
    lastName: string;
    videoReference: string | null;
}

const ScrollButton = styled(AnchorLink)`
    display: inline-block;
    font-size: 1.2em;
    font-weight: 600;
    padding: 0.6em 1.4em 0.7em;
    justify-self: start;
    align-self: end;
    border: 0 none;
    border-radius: 0.1em;
    color: ${p => p.theme.textInverted};
    background-color: ${props => props.theme.primary};
    transition: transform 0.1s ease-out;
    transform: translateY(0);
    box-sizing: border-box;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: 380px) {
        width: 100%;
        text-align: center;
    }
`;

const Grid = styled.div`
    display: grid;
    grid-template:
        'welcometext video'
        'button video' / minmax(20rem, 1fr);
    grid-gap: 4em;
    gap: 4em;

    @media (max-width: 800px) {
        grid-template:
            'welcometext'
            'video'
            'button' 6em;
        grid-gap: 1em;
        gap: 1em;
    }
`;

const withVideo = (props: PersonalWelcomeProps) => (
    <Container>
        <Grid>
            <div>
                <h1>
                    Dear {props.firstName} {props.lastName}
                </h1>
                <p>
                    We are happy to have you onboard for the next stage. On this V-Sponse space, you can watch the
                    hiring manager’s video outlining what he/she expects from the successful candidate and how success
                    will be measured for this role. Then, we would like to ask you to address a number of key questions
                    by recording one video per answer, showcasing why you are the right candidate for this position.
                </p>
            </div>
            <HiringManagerVideo videoReference={props.videoReference} />
            <ScrollButton href="#videos">Record answers</ScrollButton>
        </Grid>
        <div id="videos" />
    </Container>
);

const withoutVideo = (props: PersonalWelcomeProps) => (
    <Container>
        <h1>
            Dear {props.firstName} {props.lastName}
        </h1>
        <p>
            We are happy to have you onboard for the next stage. We would like to ask you to address a number of key
            questions by recording one video per answer, showcasing why you are the right candidate for this position.
        </p>
        <ScrollButton href="#videos">Record answers</ScrollButton>

        <div id="videos" />
    </Container>
);

const PersonalWelcome: React.FC<PersonalWelcomeProps> = props => {
    return <Section gray>{props.videoReference ? withVideo(props) : withoutVideo(props)}</Section>;
};

export default PersonalWelcome;



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/PersonalWelcome.tsx